// extracted by mini-css-extract-plugin
export default {"logoutBtn":"styles_logoutBtn__BqkYW","profileLink":"styles_profileLink__BUNtX"};